import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { SkeletonBlock } from "./PublicPortalSkeleton";

const PublicPortalFaq = ({ contact, faqs, isLoading = false }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const { t } = useTranslation("publicPortal");
  const faqItems = Array.isArray(faqs) ? faqs : [];
  const contactPrompt = contact?.prompt || "";
  const contactEmail = contact?.email || "";

  return (
    <section className="w-full px-5 pb-14 sm:px-8 lg:px-12">
      <h2 className="mb-7 text-center text-2xl font-bold text-cfHeadingText">
        {t("faq.title")}
      </h2>
      <div className="grid items-start gap-3 md:grid-cols-2">
        {faqItems.map((faq, index) => {
          const isOpen = activeIndex === index;
          const answerId = `public-portal-faq-${index}`;

          return (
            <article
              className={`relative rounded-xl border bg-cfSecondary transition-shadow ${
                isOpen
                  ? "z-20 border-cfPrimary shadow-lg"
                  : "z-0 border-cfCardBorder"
              }`}
              key={faq.question}
            >
              <button
                type="button"
                className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left text-sm font-semibold text-cfCardTagText focus:outline-none"
                aria-expanded={isOpen}
                aria-controls={answerId}
                onClick={() => setActiveIndex(isOpen ? null : index)}
              >
                {faq.question}
                <ChevronDown
                  aria-hidden="true"
                  className={`shrink-0 text-cfPrimary transition-transform ${
                    isOpen ? "rotate-180" : ""
                  }`}
                  size={18}
                />
              </button>
              {isOpen && (
                <div
                  id={answerId}
                  className="absolute left-0 right-0 top-full z-30 mt-[-1px] rounded-b-xl border border-t-0 border-cfPrimary bg-cfSecondary px-5 py-4 shadow-lg"
                >
                  <p className="m-0 text-sm leading-6 text-cfGlobalText">
                    {faq.answer}
                  </p>
                </div>
              )}
            </article>
          );
        })}
      </div>

      {isLoading ? (
        <SkeletonBlock className="mx-auto mt-7 h-4 w-80" />
      ) : contactEmail ? (
        <p className="mb-0 mt-7 text-center text-sm text-cfGlobalText">
          {contactPrompt}{" "}
          <a
            className="font-semibold text-cfPrimary underline hover:text-cfPrimaryDark"
            href={`mailto:${contactEmail}`}
          >
            {contactEmail}
          </a>
        </p>
      ) : null}
    </section>
  );
};

export default PublicPortalFaq;
